import React from 'react';
import styles from '@pages/api-portal/styles.module.scss';
import { getStatusMeta, JSON_TOKEN_COLORS, tokenizeJsonLine } from '@pages/api-portal/utils';
import { TryItOutExecutionResult } from '@pages/api-portal/types';

interface ResponsePanelProps {
    result: TryItOutExecutionResult;
}

/*
 * Renders the Try It Out response: status/latency summary, headers, and a syntax-highlighted body.
 */
export function ResponsePanel({ result }: ResponsePanelProps) {
    const { color, background, label } = getStatusMeta(result.status);
    const pillStyle = { background };
    const bodyString = typeof result.body === 'string' ? result.body : JSON.stringify(result.body, null, 2);

    return (
        <div style={{ marginTop: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span className={styles.badge} style={pillStyle}>
                    <span className={styles.badgeDotInline} style={{ background: color }} />
                    {result.status} {result.statusText}
                </span>
                <span className={styles.badge} style={pillStyle}>
                    <span className={styles.badgeDotInline} style={{ background: color }} />
                    {label}
                </span>
                <span className={styles.mutedText} style={{ fontSize: 12 }}>
                    {result.latency}ms
                </span>
            </div>
            <pre className={styles.codeBlock} style={{ maxHeight: 320 }}>
                {bodyString.split('\n').map((line, i) => (
                    <div key={i}>
                        {tokenizeJsonLine(line).map((token, j) => (
                            <span key={j} style={{ color: JSON_TOKEN_COLORS[token.type] }}>
                                {token.text}
                            </span>
                        ))}
                    </div>
                ))}
            </pre>
        </div>
    );
}
